import { t } from "@redotech/redo-i18n";
import { type PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";
import { AbTestAccessGate } from "../../../setting/ab-tests/ab-test-access";

/** One test's editor or coverage builder; the list and a test's results keep the page chrome. */
export function inAbTestEditor(url: string): boolean {
  return (
    !!matchPath("/stores/:storeId/returns/ab-tests/:testId/*", url) &&
    !matchPath("/stores/:storeId/returns/ab-tests/:testId/results", url)
  );
}

export const abTestRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("A/B tests");
      },
    },
    path: "ab-tests",
    element: <AbTestAccessGate />,
    children: [
      {
        path: "",
        lazy: async () => {
          const { AbTestsPage } =
            await import("../../../setting/ab-tests/ab-tests-page");
          return { Component: AbTestsPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("Configure test");
          },
        },
        path: ":testId",
        lazy: async () => {
          const { AbTestPage } =
            await import("../../../setting/ab-tests/ab-test-page");
          return { Component: AbTestPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("Results");
          },
        },
        path: ":testId/results",
        lazy: async () => {
          const { AbTestResultsPage } =
            await import("../../../setting/ab-tests/ab-test-results-page");
          return { Component: AbTestResultsPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("Coverage builder");
          },
        },
        path: ":testId/treatments/:treatmentId/coverage-builder",
        lazy: async () => {
          const { TreatmentCoverageBuilderPage } =
            await import("../../../setting/ab-tests/treatment-coverage-builder-page");
          return { Component: TreatmentCoverageBuilderPage };
        },
      },
    ],
  },
];
